import { gql } from '@apollo/client';
import { ExtTalentListFields } from './fragments';

export const ADMIN_SEARCH_EXT_TALENTS = gql`
  query AdminSearchExtTalents($input: AdminSearchExtTalentsInput!) {
    adminSearchExtTalents(input: $input) {
      entities {
        ...ExtTalentListFields
      }
      total
      offset
      limit
    }
  }
  ${ExtTalentListFields}
`;

export const ADMIN_EXT_TALENT_EXPORT_OPTIONS = gql`
  query AdminExtTalentExportOptions {
    adminExtTalentExportOptions {
      columns {
        header
        key
      }
    }
  }
`;

export const ADMIN_EXPORT_EXT_TALENTS = gql`
  query AdminExportExtTalents($input: ExportExtTalentsInput!) {
    adminExportExtTalents(input: $input) {
      csvUrl
    }
  }
`;
